@if (showModal()) {
  <div class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1500] p-4">
    <div
        class="bg-dark-gray rounded-2xl border border-white/10 shadow-glow max-w-md w-full animate-appear overflow-hidden">
      <div class="p-6 flex flex-col items-center">
        <div class="text-electric-blue mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-white mb-3">Oops! Let's try that again</h2>
        <p class="text-white/70 text-center mb-6">We're having a bit of trouble connecting to our servers. This usually
          resolves quickly!</p>
        <div class="flex justify-center mb-4">
          <button (click)="closeModal()"
                  class="btn btn-primary py-2 px-6 text-white bg-gradient-to-r from-electric-blue to-electric-blue/80 hover:shadow-glow-sm hover:-translate-y-0.5 transition-all rounded-lg">
            Close
          </button>
        </div>
        @if (errorData()?.errorDetails) {
          <button (click)="toggleErrorDetails()"
                  class="text-white/50 text-sm underline hover:text-white/70 transition-colors mt-2">
            {{ showErrorDetails() ? 'Hide technical details' : 'Show technical details' }}
          </button>
          @if (showErrorDetails()) {
            <div class="mt-4 p-3 bg-dark-blue/30 rounded-lg text-white/70 text-sm font-mono w-full text-left">
              <div class="mb-1">Error Code: <span class="text-electric-blue">{{ errorData()?.errorCode }}</span></div>
              <div>{{ errorData()?.errorMessage }}</div>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
